import * as React from 'react';

import { AppRoutes } from 'constants/routes';

import ArrowLeft from 'assets/icons/arrows/arrow-left-16.svg';

import CircleButton from 'basics/buttons/CircleButton';
import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';
import {
    Bar,
    SkeletonRow,
    SkeletonStack,
} from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { Sidebar } from './ProposalLoading.styled';
import {
    BackTo,
    Id,
    LeftContent,
    ProposalQuestion,
    ProposalSection,
    QuestionText,
    TabNav,
    TabNavContent,
    TabNavItem,
    Title,
} from './ProposalScreen.layout';

import { Container } from '../Sidebar/Sidebar.layout';

const ProposalLoading = () => (
    <ContentPlaceholder label="Loading proposal">
        <ProposalQuestion>
            <ProposalSection>
                <LeftContent>
                    <BackTo>
                        <CircleButton
                            label="Proposals"
                            to={AppRoutes.section.governance.link.index}
                        >
                            <ArrowLeft />
                        </CircleButton>
                    </BackTo>
                    <Id>
                        <Bar $width="12rem" $height="2.8rem" />
                    </Id>
                    <QuestionText as="div">
                        <SkeletonStack>
                            <Bar $width="90%" $height="5.6rem" />
                            <Bar $width="65%" $height="5.6rem" />
                        </SkeletonStack>
                    </QuestionText>
                </LeftContent>
            </ProposalSection>
        </ProposalQuestion>
        <TabNav aria-hidden="true">
            <TabNavContent>
                {['Proposal', 'Discussion', 'Details', 'Results'].map((label, i) => (
                    <TabNavItem key={label} $active={i === 0}>
                        {label}
                    </TabNavItem>
                ))}
            </TabNavContent>
        </TabNav>
        <Sidebar aria-hidden="true">
            <Container>
                <SkeletonStack $gap="2.4rem">
                    <Bar $width="65%" $height="2.8rem" />
                    <Bar $width="100%" $height="6rem" />
                    {[0, 1, 2].map(i => (
                        <SkeletonRow key={i}>
                            <Bar $width="40%" />
                            <Bar $width="25%" />
                        </SkeletonRow>
                    ))}
                    <Bar $width="100%" $height="0.8rem" />
                    <Bar $width="100%" $height="4.8rem" />
                </SkeletonStack>
            </Container>
        </Sidebar>
        <ProposalSection>
            <LeftContent>
                <Title>Proposal</Title>
                <SkeletonStack>
                    {Array.from({ length: 9 }, (_, i) => (
                        <Bar key={i} $width={i === 8 ? '65%' : '100%'} $height="1.6rem" />
                    ))}
                </SkeletonStack>
            </LeftContent>
        </ProposalSection>
    </ContentPlaceholder>
);

export default ProposalLoading;
